export const MAX_OPTION_NAME_LENGTH = 50
export const MAX_OPTION_DESCRIPTION_LENGTH = 100

export const Resources = {
  singleSelectOptionLimitWarning: (count: number) => `Maximum of ${count} options reached`,
}

export const VALIDATION_MESSAGES = {
  REQUIRED: 'Label text is required',
  NAME_TOO_LONG: `Label text must be ${MAX_OPTION_NAME_LENGTH} characters or fewer`,
  DESCRIPTION_TOO_LONG: `Description must be ${MAX_OPTION_DESCRIPTION_LENGTH} characters or fewer`,
  DUPLICATE: 'Option has already been taken',
  NAME_CONTAINS_COMMA: 'Option names cannot contain ","',
} as const
